import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import moment from "moment";
import dasherize from "underscore.string/dasherize";
//utils
import { getUser } from "utils/auth";
//actions
import { actions } from "actions/resources";
//components
import NewCompanyForm from "./forms/new";
import { Col, Row, Table, Typography } from "antd";
//images
import defaultCompanyImage from "images/default_company.png";
import { Link } from "react-router-dom";

import { uploadPhoto } from "utils/image";

import { LogoUploader } from "../../../components/generic/LogoUploader";

import { companiesIndex } from "../../../utils/algolia";

import { searchClients, searchCompanies } from "actions/search";


const clientColumns = [
  {
    width: 300,
    title: "User",
    dataIndex: "first_name",
    key: "client_name",
    sorter: (a, b) => {
      return a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase());
    },
    render: (text, record) => {
      return (
        <div>
          <Link to={`/companies/client/edit/${record.id}`}>{record.first_name + " " + record.last_name}</Link>
        </div>
      );
    }
  },
  {
    width: 300,
    title: "Title",
    dataIndex: "title",
    key: "title",
    sorter: (a, b) => {
      return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
    },
    render: (text, record) => {
      return (
        <div>
          <span>
            {record.title}
          </span>
        </div>
      );
    }
  },
  {
    width: 200,
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    sorter: (a, b) => {
      return a.status.toLowerCase().localeCompare(b.status.toLowerCase());
    },
    render: (text, record, e) => {
      return (
        <div>
          <span>
            {record.status}
          </span>
        </div>
      );
    }
  },
  {
    width: 100,
    title: "Date",
    key: "created_at",
    align: "center",
    render: (a) => { return moment(a.created_at).format("M/D/YYYY"); }
  }

];

export class NewCompany extends Component {
  state = {
    formCompany: null
  };

  constructor(props) {
    super(props);
    this.companyPictureRef = React.createRef();
  }

  componentWillMount() {
    this._fetchDependencies();
  }

  _fetchDependencies = async () => {
    const { fetchCompany, fetchClients, match } = this.props;
    if (match.params.id) {
      const record = await fetchCompany(match.params.id);
      const { payload } = record;
      const formattedObject = {
        name: payload.name,
        city: payload.city,
        state: payload.state,
        logo: payload.logo,
        industry: payload.industry,
        number_of_employees: payload.number_of_employees,
        linkedin_url: payload.linkedin_url,
        website_url: payload.website_url,
        status: payload.status
      };

      fetchClients({ company_id: match.params.id });
      return this.setState({ formCompany: formattedObject });
    }

    this.setState({
      formCompany: null
    });
  };

  _createCompany = async data => {
    const { createCompany, redirect } = this.props;

    this._processPayload(data, {
      creator_id: getUser().id
    }).then(async (result) => {
      // console.log("COMPANY", result);
      const response = await createCompany(result);
      if (response) {
        this.setState({ selectedCompany: null });
        redirect(`/companies`);
      }
    });
  };

  _processPayload = async (data, extraParams = {}) => {
    let payload = {
      ...{
        name: data.name,
        city: data.city,
        state: data.state,
        industry: data.industry,
        number_of_employees: data.number_of_employees,
        linkedin_url: data.linkedin_url,
        website_url: data.website_url,
        status: data.status
      },
      ...extraParams
    };
    return new Promise((resolve, reject) => {
      if (this.companyPictureRef.current && this.companyPictureRef.current.value.length > 0) {

        let fileKey = `company-pictures/${dasherize(data.name)}${moment().valueOf()}`;

        let imageData = {
          fileKey: fileKey,
          image: this.companyPictureRef.current.value
        };

        uploadPhoto(imageData).then((value) => {
          payload = {
            ...payload,
            ...{ logo: `https://assets.wesolv.com/${imageData.fileKey}` }
          };
          resolve(payload);
        });

      } else {
        resolve(payload);
      }
    });
  };

  _updateCompany = async data => {
    const { match, updateCompany, redirect } = this.props;
    this._processPayload(data).then(async (result) => {
      // console.log("COMPANY", result);
      const response = await updateCompany(match.params.id, result);
      if (response) {
        this.setState({ selectedCompany: null });
        redirect(`/companies`);
      };
    });
  };

  _deleteCompany = async data => {
    const { company, deleteCompany, redirect } = this.props;
    await deleteCompany(company.id);
    setTimeout(() => {
      // redirect(`/companies/`);
      window.location = "/companies";
    }, 2000);
  }

  render() {
    const { company, clients, match, redirect } = this.props;
    const { formCompany } = this.state;
    const { Title } = Typography;

    let logoImage = (company && company.logo) || defaultCompanyImage;

    // console.log("company", company, "logoImage", logoImage);

    if (match && match.params.id && formCompany && company) {
      return (
        <Row className="detail-spacer">
          <Row>
            <Col span={24}>
              <Row>
                <Col type="flex" justify="center" align="middle">
                  <h1 id="header">Edit Company</h1>
                </Col>
              </Row>
              <br />
              <Row type="flex" justify="center">
                <LogoUploader
                  currentImage={logoImage}
                  ImageRef={this.companyPictureRef} />
              </Row>
              <br />
              <Row type="flex" justify="center">
                <Col span={20}>
                  <NewCompanyForm
                    initialValues={formCompany}
                    deleteCompany={this._deleteCompany}
                    onSubmit={this._updateCompany}
                    redirect={redirect}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ paddingTop: 40 }} >
            <Title level={4}>Associated Company Users</Title>
          </Row>
          <Row justify="center" align="middle">
            <Table
              columns={clientColumns}
              dataSource={clients}
              rowKey="id"
              size="small"
              scroll={{ x: 600 }}
            />
          </Row>
        </Row>
      );
    } else {
      logoImage = defaultCompanyImage;
    }

    return (
      <Row className="detail-spacer">
        <Row>
          <Col span={24}>
            <Row>
              <Col type="flex" justify="center" align="middle">
                <h1 id="header">Add Company</h1>
              </Col>
            </Row>
            <br />
            <Row type="flex" justify="center">

              <LogoUploader
                currentImage={logoImage}
                ImageRef={this.companyPictureRef} />

            </Row>
            <br />
            <Row type="flex" justify="center">
              <Col span={20}>
                <NewCompanyForm
                  onSubmit={this._createCompany}
                  redirect={redirect}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
    );
  }
}

export default connect(
  state => ({
    company: state.resources.detail.company,
    clients: state.resources.collection.client || []
  }),
  dispatch => ({
    createCompany: bindActionCreators(actions.createCompany, dispatch),
    fetchCompany: bindActionCreators(actions.fetchCompany, dispatch),
    fetchClients: bindActionCreators(actions.fetchClients, dispatch),
    deleteCompany: bindActionCreators(actions.deleteCompany, dispatch),
    redirect: bindActionCreators(push, dispatch),
    updateCompany: bindActionCreators(actions.patchCompany, dispatch),

    searchClients: bindActionCreators(searchClients, dispatch),
    searchCompanies: bindActionCreators(searchCompanies, dispatch)
  })
)(NewCompany);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/new.js